import { render } from "./FormShareDialog.vue?vue&type=template&id=f1b2d02e&scoped=true"
import script from "./FormShareDialog.vue?vue&type=script&lang=js"
export * from "./FormShareDialog.vue?vue&type=script&lang=js"

import "./FormShareDialog.vue?vue&type=style&index=0&id=f1b2d02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b2d02e"]])

export default __exports__